import { CHART_X_PADDING } from "../../../../components/chart/hooks"
import { styled, theme } from "../../../../styles/stitches.config"

export const SCard = styled("div", {
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadows.default,
  padding: `${theme.space.s7} ${theme.space.s9}`,

  display: "flex",
  flexWrap: "wrap",
  gap: theme.space.s6,
  justifyContent: "space-around",
  flexShrink: 0,

  textAlign: "center",

  "@sm": {
    flexWrap: "nowrap",
    textAlign: "unset",
  },
})

export const SSwitchAndLabelContainer = styled("div", {
  display: "flex",
  flexDirection: "column-reverse",
  alignItems: "center",
  justifyContent: "space-between",

  gap: theme.space.s4,
  paddingLeft: 0,
  width: "100%",

  "@sm": {
    flexDirection: "row",
    gap: 0,
    paddingLeft: CHART_X_PADDING,
  },
})

export const SOptimizationSummaryItem = styled("div", {
  textAlign: "center",
  minWidth: theme.sizes.s28,

  variants: {
    textAlignOnSm: {
      start: {
        "@sm": {
          textAlign: "start",
        },
      },
      end: {
        "@sm": {
          textAlign: "end",
        },
      },
      center: {
        "@sm": {
          textAlign: "center",
        },
      },
    },
  },
})
